import React from 'react';
import Icon from '../../../../../components/common/icon/icon';
import { NewIconNames } from '../../../../../components/common/icon/new-icon-names';
import Progress from '../../../../../components/progress/progress';
import { OperationStatus } from '../../../operation-groups/operation-groups.types';
import { LoaderXSmall } from '../loader-xsmall/loader-xsmall';
import styles from './non-hover-status.scss';

interface Props {
  status: OperationStatus;
  progress?: number;
}

export const NonHoverStatus: React.FunctionComponent<Props> = ({
  status,
  progress,
}: Props) => {
  switch (status) {
    case OperationStatus.InProgress: {
      if (progress === undefined) {
        return <LoaderXSmall />;
      }

      return <Progress progress={progress} width={18} height={18} />;
    }

    case OperationStatus.Failed:
    case OperationStatus.Canceled:
      return (
        <Icon
          name={NewIconNames.StatusAlertFilled}
          className={styles.errorCircle}
        />
      );

    case OperationStatus.Succeeded:
      return <Progress progress={100} width={18} height={18} />;

    case OperationStatus.Pending:
    default:
      return <Progress progress={0} width={18} height={18} />;
  }
};
